import * as Sentry from '@sentry/vue'
import { STORE_RELOAD_RATE_LIMIT_MESSAGE } from './storeReloadRateLimit'
import { pwaConfig } from './pwaTools'
import { sentryCountMetric } from './sentryMetrics.ts'

/** Reports repeated store-hydration hard reloads (user is signed out after this). */
export function reportStoreReloadRateLimitToSentry(reloadTimestamps: number[]): void {
  const error = new Error(STORE_RELOAD_RATE_LIMIT_MESSAGE)

  Sentry.withScope((scope) => {
    scope.setLevel('warning')
    scope.setFingerprint(['client-store-reload-rate-limit'])
    scope.setTag('client.issue', 'store_reload_rate_limit')
    scope.setTag('displayMode', pwaConfig.displayMode)
    scope.setTag('browserInfoName', pwaConfig.browserInfo.name)
    scope.setTag('browserInfoOs', pwaConfig.browserInfo.os)
    scope.setExtras({
      reloadTimestamps,
      windowMs: 30_000,
      limit: 2,
      pathname: typeof window !== 'undefined' ? window.location.pathname : undefined,
    })
    Sentry.captureException(error)
  })

  sentryCountMetric('client.store_reload_rate_limit')
}
